import Vue from 'vue';
import DEFINES from'@/defines'

Vue.filter('confidential', function(value, replaceBy = '*', visibility = 4) {
  if (!value) return 0;
  value = value.toString();
  var length = value.length;

  var subString = value.substr(-visibility);

  var right_padding = length - visibility;

  return replaceBy.repeat(right_padding).concat(subString);
});

/**
 * Filter screening and VOD events by is_vod_event flag
 */
Vue.filter ('EventType', function (items, type) {
  if (!items) return '';
  // Filter all standard events dynamically
  if(type == DEFINES.EVENT_TYPE.VOD_EVENTS) return items.filter (item => item.is_vod_event == true);

  // Filter all vod events dynamically
  if(type == DEFINES.EVENT_TYPE.STANDARD_EVENTS) return items.filter (item => item.is_vod_event == false);
});

Vue.filter ('fixed', function (value, decimal = 2) {
  if (!value) return 0;
  value = parseFloat (value);
  return value.toFixed (decimal);
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})